import { InterfaceFactoryOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { ComponentLogic } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-logic/base/component-logic';
import { IBaseComponent } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/base-component/base-component.interface';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { PlaceholderElement } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/place-holder-component/placeholder-element';
import { PlaceHolderMode } from '@src/slide/domain/ui-model/element-modeles/property/placeholder/PlaceHolderMode';
import TableMenu from '@src/framework/frame/components/tool-bar/menu/table-menu';

export class PlaceHolderIconLogic extends ComponentLogic {
    declare protected component: PlaceholderElement;
    declare protected componentOptions: InterfaceFactoryOptions<IShapeModel>;

    public constructor(componentOptions: InterfaceFactoryOptions<IElementBaseModel>, component: IBaseComponent) {
        super(componentOptions, component);
        this.component.setEventHandlers({
            handleIconClick: this.handleIconClick,
        });
    }

    private handleIconClick = async (type) => {
        this.componentOptions.selectionService?.selectedElements.clear();
        this.componentOptions.selectionService?.selectedElements.add(this.componentOptions.model);
        switch (type) {
            case PlaceHolderMode.PIC: {
                const copyPasteImageService = await this.componentOptions
                    .copyPasteImageService?.promise();
                const { ImageEditManager } = copyPasteImageService ?? {};
                const imageManager = ImageEditManager?.getInstance();
                const input = document.getElementById('select_pic_input');
                if (imageManager) {
                    imageManager.imageReplacing = false;
                }
                input?.click();
                break;
            }
            case PlaceHolderMode.TBL: {
                const tm = new TableMenu({});
                // @ts-ignore
                tm.showDialog();
                break;
            }
        }
    };
}
